var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20CheckSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.617 4.56851C12.8552 4.79882 12.8617 5.17866 12.6313 5.41692L6.83135 11.4169C6.71684 11.5354 6.55867 11.6015 6.39393 11.5999C6.22919 11.5982 6.07238 11.5289 5.96028 11.4082L3.36028 8.60817C3.1348 8.36535 3.14886 7.98571 3.39168 7.76023C3.63451 7.53474 4.01415 7.5488 4.23963 7.79163L6.40871 10.1276L11.7686 4.58289C11.9989 4.34464 12.3787 4.3382 12.617 4.56851Z",
    fill: "#0EA374"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20CheckSmall);
export default __webpack_public_path__ + "static/media/20-check-small.7af61bab258089cf6125e156667895c5.svg";
export { ForwardRef as ReactComponent };